// extracted by mini-css-extract-plugin
export var blogpostsContainer = "related-posts-module--blogposts-container--z8MGi";
export var relatedPostsContainer = "related-posts-module--related-posts-container--867QH";